





















































import {Component} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import Navbar from '@/components/navbar/Navbar.vue'
import OrbitBanner from '@/components/orbit/OrbitBanner.vue'
import OrbitTableSection from '@/components/orbit/OrbitTableSection.vue'
import OrbitLeaderboardCards from '@/components/orbit/OrbitLeaderboardCards.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import {MetaInfo} from 'vue-meta'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {OrbitLeaderboardCollection} from '@/model/collection/OrbitLeaderboardCollection'
import {OrbitLeaderboardSummary} from '@/model/resource/OrbitLeaderboardSummary'

@Component({
  components: {
    OrbitTableSection,
    OrbitBanner,
    OrbitLeaderboardCards,
    AppFooter,
    Navbar,
  },
})
export default class OrbitView extends MixinScreenSize {
  activeRound = 0
  lastRound = 0
  optionSelected: 'currentRound' | 'previousRound' | 'leaderboard' =
    'currentRound'
  hasRound = false
  summary = new OrbitLeaderboardSummary()

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.orbit'),
    }
  }

  mounted() {
    if (!this.isOrbitEnabled) return
    this.populateResources()
  }

  async populateResources() {
    await this.$await.run('populateRound', async () => {
      const [activeRound, lastRound, summary] = await Promise.all([
        OrbitHelper.getActiveRound(),
        OrbitHelper.getLastRound(),
        new OrbitLeaderboardCollection().getOrbitLeaderboardSummary(),
      ])

      this.activeRound = Number(activeRound) || 0
      this.lastRound = Number(lastRound)
      this.summary = summary

      if (this.activeRound === 0 && this.lastRound === 0) {
        this.hasRound = false
      } else {
        this.hasRound = true
      }
    })
  }

  handleOptionSelected(
    option: 'currentRound' | 'previousRound' | 'leaderboard'
  ) {
    this.optionSelected = option
  }
}
